document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".hero-slider").forEach(initHeroSlider);

});

document.addEventListener("shopify:section:load", (e) => {

  const slider = e.target.querySelector(".hero-slider");

  if (slider) {
    initHeroSlider(slider);
  }

});

function initHeroSlider(section) {

  if (section.dataset.initialized) return;

  section.dataset.initialized = "true";

  const slides = [...section.querySelectorAll(".hero-slide")];

  if (!slides.length) return;

  const prev = section.querySelector(".hero-slider-prev");
  const next = section.querySelector(".hero-slider-next");
  const dotsWrapper = section.querySelector(".hero-slider-dots");

  const autoplay =
    section.dataset.autoplay === "true";

  const delay =
    parseInt(section.dataset.delay) || 5000;

  let current = 0;

  let timer = null;

  /*----------------------------------
  SHOW SLIDE
  -----------------------------------*/

  function showSlide(index) {

    slides.forEach((slide, i) => {

      slide.classList.toggle(
        "is-active",
        i === index
      );

    });

    current = index;

    updateDots();

  }

  /*----------------------------------
  NEXT
  -----------------------------------*/

  function nextSlide() {

    current++;

    if (current >= slides.length) {
      current = 0;
    }

    showSlide(current);

  }

  /*----------------------------------
  PREVIOUS
  -----------------------------------*/

  function prevSlide() {

    current--;

    if (current < 0) {
      current = slides.length - 1;
    }

    showSlide(current);

  }

  /*----------------------------------
  BUTTONS
  -----------------------------------*/

  if (next) {

    next.addEventListener("click", nextSlide);

  }

  if (prev) {

    prev.addEventListener("click", prevSlide);

  }

  /*----------------------------------
  DOTS
  -----------------------------------*/

  function updateDots() {

    if (!dotsWrapper) return;

    [...dotsWrapper.children].forEach((dot, index) => {

      dot.classList.toggle(
        "active",
        index === current
      );

    });

  }

  if (dotsWrapper) {

    dotsWrapper.innerHTML = "";

    slides.forEach((slide, index) => {

      const dot = document.createElement("button");

      dot.type = "button";

      dot.className = "hero-dot";

      dot.addEventListener("click", () => {

        showSlide(index);

        restartAutoplay();

      });

      dotsWrapper.appendChild(dot);

    });

  }

  /*----------------------------------
  AUTOPLAY
  -----------------------------------*/

  function startAutoplay() {

    if (!autoplay || slides.length <= 1) return;

    timer = setInterval(() => {

      nextSlide();

    }, delay);

  }

  function stopAutoplay() {

    clearInterval(timer);

  }

  function restartAutoplay() {

    stopAutoplay();

    startAutoplay();

  }

  section.addEventListener(
    "mouseenter",
    stopAutoplay
  );

  section.addEventListener(
    "mouseleave",
    startAutoplay
  );

  /*----------------------------------
  TOUCH SUPPORT
  -----------------------------------*/

  let startX = 0;

  section.addEventListener("touchstart", e => {

    startX = e.touches[0].clientX;

  });

  section.addEventListener("touchend", e => {

    const endX = e.changedTouches[0].clientX;

    if (Math.abs(endX - startX) < 40) return;

    if (endX < startX) {

      nextSlide();

    } else {

      prevSlide();

    }

    restartAutoplay();

  });

  /*----------------------------------
  INIT
  -----------------------------------*/

  showSlide(0);

  startAutoplay();

}